
import SubscribeMixin from "~/mixin/subscribe-mixin";
import FormatMixin from "~/mixin/format-mixin";
import calDynamicLandingProducts from "./cal-dynamic-landing-products.vue";
import EventValidationMixin from "~/mixin/event-validation-mixin";
import CitySelection from "~/components/filter-section/cal-city-section.vue";
import DeliveryDateSelection from "~/components/filter-section/cal-delivery-date-selection.vue";
import CalDeliveryDateSelection from "../components/filter-section/cal-delivery-date-selection.vue";

export default {
  components: { calDynamicLandingProducts,
    CitySelection,
    DeliveryDateSelection,
    CalDeliveryDateSelection, },
  name: "cal-dynamic-landing-page",
  mixins: [SubscribeMixin, FormatMixin, EventValidationMixin],
  props: {
    componentPickerData: {
      type: Array | undefined,
      required: true,
    },
    deliveryDate: {
      type: String,
      required: false,
      default: sessionStorage.deliveryDate ? sessionStorage.deliveryDate : ""
    },
    ddModalImg: {
      type: String,
      required: false,
    },
    useSlideV2: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      metaTags: {},
      form: {
        name: "",
        email: "",
      },
      alertMessage: "",
      showAlert: false,
      deliveryTown: sessionStorage.deliveryTown
        ? JSON.parse(sessionStorage.deliveryTown)
        : {},
      isShowFilterSection:true,
    };
  },
  watch: {
    "form.name"() {
      this.validateFormDetails();
    },
    "form.email"(value) {
      this.form.email = value;
      this.validateFormDetails(value);
    },
    deliveryDate(){
      this.getDeliveryDate(this.deliveryDate);
    }
  },
  created(){
    if(this.$route.path.includes('events') || this.$route.path.includes('bulk-florals')){
      this.isShowFilterSection = false;
    }
  },
  methods: {
    getCity(city) {
      this.deliveryTown = city;
      sessionStorage.setItem("deliveryTown", JSON.stringify(this.deliveryTown));
      this.deliveryDate = sessionStorage.deliveryDate;
    },
    getDeliveryDate(deliveryDate) {
      this.deliveryDate = deliveryDate;
      sessionStorage.deliveryDate = this.deliveryDate;
    },
    openSeasonalPDFS(url) {
      //TODO: remove this and add to HoverItem in callia-ui-box
      window.open(url, "_blank").focus();
    },
    validateFormDetails(value) {
      return !(this.form.name && this.isEmailValid(value));
    },
    closeAlertDialog() {
      this.form.name = "";
      this.form.email = "";
      this.showAlert = false;
    },
    async submit() {
      try {
        await this.subscribe(
          this.$axios,
          this.form.name,
          this.form.email,
          this.$i18n.locale.split("-"),
          (this.alertMessage =
            this.$t("success_message1") +
            this.form.name +
            this.$t("success_message2"))
        );
      } catch (error) {
        console.error(error);
      }
      this.showAlert = true;
    },
    redirectToButtonRoute(path) {
      return path.startsWith("$")
        ? this.emitCustomButtonEvent({ type: path, data: "" })
        : path.startsWith("https")
        ? window.open(path, "_blank")
        : this.$router.push(path);
    },
  },
};
